import { Skeleton } from '@mui/material'
import styled, { keyframes } from 'styled-components'
import { theme } from '../theme/theme'

export const ImageSkeleton = () => {
  return <StyledSkeleton variant="rectangular" animation="wave" />
}

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

const StyledSkeleton = styled(Skeleton)`
  max-width: 400px;
  width: 100%;
  border-radius: 6px;
  animation: ${fadeInScale} 0.8s ease-out;
  margin-bottom: ${theme.spacing.medium}px;

  && {
    height: 500px;
    max-height: 500px;
  }

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    && {
      height: 50vh;
      max-height: 50vh;
    }
  }
`
